import React from 'react';
import StaticPage from '../components/layout/StaticPage';

const FaqItem = ({ q, a }) => (
    <div className="mb-6 border-b border-gray-100 pb-6 last:border-0 group">
        <h3 className="font-bold text-lg text-gray-900 mb-2 group-hover:text-pink-600 transition-colors flex items-start gap-2">
            <span className="text-pink-400 mt-1 text-sm">Q.</span> {q}
        </h3>
        <p className="text-gray-600 pl-6 border-l-2 border-gray-200 ml-1">{a}</p>
    </div>
);

export default function FaqPage() {
    return (
        <StaticPage title="Frequently Asked Questions" description="Answers to common questions about booking party rentals, payments, and vendor accounts.">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div>
                    <div className="flex items-center gap-2 mb-6">
                        <span className="text-2xl">🎉</span>
                        <h2 className="text-2xl font-bold text-gray-900 m-0">For Planners</h2>
                    </div>
                    <FaqItem 
                        q="How does the booking process work?" 
                        a="Find an item you love, select your dates, and send a 'Request to Book'. The vendor will review your request. Once accepted, you'll receive a notification to complete payment securely through our platform." 
                    />
                    <FaqItem 
                        q="Is payment secure?" 
                        a="Absolutely. We use Stripe, a world-class payment processor, to handle all transactions. Your financial information is never stored on our servers." 
                    />
                    <FaqItem 
                        q="What if I need to cancel?" 
                        a="Cancellation policies are set by individual vendors. Check the listing details or the rental contract provided by the vendor before booking. You can request cancellations directly from your dashboard." 
                    />
                    <FaqItem 
                        q="Can I customize invitations?" 
                        a="Yes! Our AI-powered E-vite Creator lets you design stunning invitations, track RSVPs, and even send updates to your guests via email or text." 
                    />
                </div>
                <div>
                    <div className="flex items-center gap-2 mb-6">
                        <span className="text-2xl">💼</span>
                        <h2 className="text-2xl font-bold text-gray-900 m-0">For Vendors</h2>
                    </div>
                    <FaqItem 
                        q="How do I get paid?" 
                        a="Payouts are automated via Stripe. Once a booking is completed, funds are transferred to your connected bank account according to Stripe's rolling payout schedule. You can manage this from your Stripe Standard dashboard." 
                    />
                    <FaqItem 
                        q="Can I manage my own inventory?" 
                        a="Yes. Our dashboard allows you to track stock levels, set 'buffer days' for cleaning/turnover, and block out dates for vacations or maintenance." 
                    />
                    <FaqItem 
                        q="What happens if an item is damaged?" 
                        a="We recommend including a damage waiver fee in your listings or using our contract generation tool to ensure renters sign a liability agreement protecting your assets." 
                    />
                    <FaqItem 
                        q="Does Host-it! charge fees?" 
                        a="Listing items is free. We charge a small service fee on confirmed bookings to maintain the platform and support services." 
                    />
                </div>
            </div>
        </StaticPage>
    );
}